export default __webpack_public_path__ + "1fd26ebdd17dfa8a4781775b2bd2f0fa.ogg";